import React from "react";
import Subheader from "./Subheader";

export interface TeamSubheaderProps {
  match?: any;
}

const TeamSubheader: React.FC<TeamSubheaderProps> = ({
  match,
}): JSX.Element => {
  const { teamId } = match.params;

  const subheaderDataForTeam = {
    id: teamId,
  };

  return <Subheader subheaderData={subheaderDataForTeam} />;
};

export default TeamSubheader;
